import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = _reduceInstanceProperty(typesToTry).call(typesToTry, function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}

export { getDataFromDataTransfer };
